import { render } from "./AddGood.vue?vue&type=template&id=43fc18d4"
import script from "./AddGood.vue?vue&type=script&lang=js"
export * from "./AddGood.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__